import React from 'react';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { isAndroid } from 'react-device-detect';
import { useDispatch } from 'react-redux';
import { StyledDownloadContainer } from './styled';
import { ReactComponent as DownloadIcon } from '../../../../assets/img/download-icon.svg';
import { getExportPlayersDocRequest } from '../../../../api/league';
import { showPopupWindow } from '../../../../redux/actions/Popups';
import { POPUPS } from '../../../../service/constants';

const CSVReport = ({ isPremium }) => {
  const dispatch = useDispatch();
  const [csvData, setData] = React.useState('');
  const csvRef = React.useRef();
  const getCSVData = async () => {
    const response = await getExportPlayersDocRequest();
    if (response.status === 200) {
      const res = await response.text();
      setData(res);
    }
  };
  React.useEffect(() => {
    setTimeout(() => {
      if (csvData) {
        csvRef.current.link.click();
      }
    });
  }, [csvData]);
  const downloadFile = () => {
    if (!isPremium) {
      dispatch(showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP, POPUPS.MOBILE_REQUIRED_POPUP));
    } else {
      getCSVData();
    }
  };
  return (
    <StyledDownloadContainer isPremium={isPremium} onClick={downloadFile}>
      <DownloadIcon />
      <CSVLink filename="export-players.csv" data={csvData} ref={csvRef} />
    </StyledDownloadContainer>
  );
};
CSVReport.propTypes = {
  isPremium: PropTypes.bool,
};

CSVReport.defaultProps = {
  isPremium: false,
};
export default CSVReport;
